import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import { useAuth } from "./context/AuthContext";
import EditProfileModal from "./components/player/EditProfileModal";
import { useLocation } from "react-router-dom";
import { THEME_COLOR } from "./config/club";

export default function MyProfileGate() {
  const { user, setUser } = useAuth();
  const location = useLocation();
  const joinContext = location.state;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const [editing, setEditing] = useState(false);
  const THEME_VIOLET = THEME_COLOR;
  useEffect(() => {
    if (!user) return;

    const load = async () => {
      const snap = await getDoc(doc(db, "users", user.uid));

      if (!snap.exists()) {
        navigate("/", { replace: true });
        return;
      }

      const data = snap.data();
      setProfile(data);

      if (data.username) {
        navigate(`/u/${data.username}`, {
          replace: true,
          state: joinContext
        });
      } else {
        // ✅ Stay here and force modal
        setEditing(true);
      }

      setLoading(false);
    };

    load();
  }, [user, navigate]);

  if (loading) {
    return (
      <div
        className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center profile-loader"
        style={{ zIndex: 9999, backdropFilter: "blur(6px)" }}
      >
        <div
          className="spinner-border mb-3"
          style={{
            color: THEME_VIOLET,
            width: "3rem",
            height: "3rem",
            borderWidth: "0.25em"
          }}
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>

        <div className="loader-text">
          Preparing Profile
        </div>
      </div>
    );
  }

  return (
    <>
      {editing && (
        <EditProfileModal
          user={user}
          setUser={setUser}
          profile={profile}
          forceUsername
          onClose={(updated) => {
            if (updated?.username) {
              setEditing(false);
              navigate(`/u/${updated.username}`, {
                replace: true,
                state: joinContext
              });
            }
          }}
        />
      )}
    </>
  );
}
